import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Points, PointMaterial, Sphere, MeshDistortMaterial } from '@react-three/drei';
import * as THREE from 'three';

const PendingApprovalBackground = () => {
  const pointsRef = useRef();
  const sphereRef = useRef();
  const sphere2Ref = useRef();
  const sphere3Ref = useRef();
  
  // Tạo particles cho background
  const count = 3000;
  const positions = useMemo(() => {
    const positions = new Float32Array(count * 3);
    for (let i = 0; i < count; i++) {
      positions[i * 3] = (Math.random() - 0.5) * 20;
      positions[i * 3 + 1] = (Math.random() - 0.5) * 20;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 20;
    }
    return positions;
  }, []);

  // Animation frame
  useFrame((state) => {
    if (pointsRef.current) {
      pointsRef.current.rotation.x = Math.sin(state.clock.elapsedTime * 0.05) * 0.1;
      pointsRef.current.rotation.y = Math.sin(state.clock.elapsedTime * 0.08) * 0.1;
    }
    
    if (sphereRef.current) {
      sphereRef.current.position.x = Math.sin(state.clock.elapsedTime * 0.3) * 3;
      sphereRef.current.position.y = Math.cos(state.clock.elapsedTime * 0.2) * 2;
    }
    
    if (sphere2Ref.current) {
      sphere2Ref.current.position.x = Math.sin(state.clock.elapsedTime * 0.4 + 1) * 4;
      sphere2Ref.current.position.y = Math.cos(state.clock.elapsedTime * 0.3 + 1) * 3;
    }
    
    if (sphere3Ref.current) {
      sphere3Ref.current.position.x = Math.sin(state.clock.elapsedTime * 0.2 + 2) * 5;
      sphere3Ref.current.position.y = Math.cos(state.clock.elapsedTime * 0.25 + 2) * 4;
    }
  });

  return (
    <>
      {/* Particles background */}
      <Points ref={pointsRef} positions={positions} stride={3} frustumCulled={false}>
        <PointMaterial
          transparent
          color="#60A5FA"
          size={0.03}
          sizeAttenuation={true}
          depthWrite={false}
          opacity={0.4}
        />
      </Points>
      
      {/* Floating spheres with distortion effect */}
      <Sphere ref={sphereRef} args={[1, 32, 32]} position={[0, 0, -5]}>
        <MeshDistortMaterial
          color="#3B82F6"
          speed={2}
          distort={0.3}
          radius={1}
          transparent
          opacity={0.2}
        />
      </Sphere>
      
      <Sphere ref={sphere2Ref} args={[0.8, 32, 32]} position={[3, 2, -3]}>
        <MeshDistortMaterial
          color="#8B5CF6"
          speed={1.5}
          distort={0.4}
          radius={1}
          transparent
          opacity={0.15}
        />
      </Sphere>
      
      <Sphere ref={sphere3Ref} args={[1.2, 32, 32]} position={[-4, -1, -4]}>
        <MeshDistortMaterial
          color="#EC4899"
          speed={2.5}
          distort={0.25}
          radius={1}
          transparent
          opacity={0.1}
        />
      </Sphere>
      
      {/* Additional floating elements */}
      <Sphere args={[0.3, 16, 16]} position={[2, -3, -2]}>
        <meshBasicMaterial color="#10B981" transparent opacity={0.3} />
      </Sphere>
      
      <Sphere args={[0.4, 16, 16]} position={[-2, 3, -3]}>
        <meshBasicMaterial color="#F59E0B" transparent opacity={0.25} />
      </Sphere>
    </>
  );
};

export default PendingApprovalBackground; 